/**
 * Which tree nodes to open after the user connects a database (owner,
 * 30.09.2026: "after Connect, expand down to its tables").
 *
 * Injected into the DB Manager guest source with Function.prototype.toString,
 * so it stays self-contained ES5 (see treeRefresh.js). The ids match
 * entry.js's buildRoot / buildTopNode / buildDatabaseNode / buildTablesNode.
 *
 * The host opens them all at once and loads each lazy level as it appears
 * (ExtensionTreeSection re-requests every open, unloaded lazy node on each
 * publish), so a deeper id simply waits until its parent has loaded.
 *
 *   SQLite    root -> Tables (main)
 *   Postgres  root -> Tables (public); Schemas stays closed
 *   MySQL     root -> Databases -> the configured database -> Tables,
 *             or root -> Databases when no database is configured
 */
export function connectExpandIds(saved, sep) {
  if (!saved || !saved.id) return [];
  var root = saved.id;
  var id = function (suffix) { return root + sep + suffix; };
  if (saved.engine === 'sqlite') return [root, id('db:main:tables')];
  if (saved.engine === 'postgres') return [root, id('db:public:tables')];
  var ids = [root, id('databases')];
  if (saved.database) ids.push(id('db:' + saved.database), id('db:' + saved.database + ':tables'));
  return ids;
}
